const lightbox = document.querySelector(".modul-lightbox");
const dialog = document.querySelector('.dialog-overlay')

export const initLightbox = () => {
  if (lightbox) {
    var lightboxButtons = document.querySelectorAll(".open-lightbox");

    lightboxButtons.forEach((lightboxButton) => {
      lightboxButton.addEventListener("click", () => {
        if (lightboxButton.nodeName === "IMG") {
          lightbox.classList.add("show-lightbox");
          openImageLightbox(lightboxButton);
        }
      });
    });

    const lightboxImages = document.querySelectorAll(".lightbox-img-link");
    lightboxImages.forEach((lightboxImage) => {
      lightboxImage.addEventListener("click", (event) => {
        event.preventDefault();
        lightbox.classList.add("show-lightbox");
        moveContentImageToLightbox(lightboxImage);
      });
    });

    const lightboxCloseButtons = document.querySelectorAll(".close-lightbox");
    lightboxCloseButtons.forEach((button) => {
      button.addEventListener("click", () => {
        clearLightbox();
        clearDialog()
      });
    });
  }
};

const openImageLightbox = (lightboxButton) => {
  const lightboxContent = lightbox.querySelector('.lightbox-content')
  if(lightboxContent) {
    const lightboxImage = lightboxButton.cloneNode(false)
    lightboxImage.classList.remove('open-lightbox')
    lightboxContent.appendChild(lightboxImage)
  }
};

const clearLightbox = () => {
  lightbox.classList.remove("show-lightbox");
  const lightboxContent = lightbox.querySelector(".lightbox-content");
  if (lightboxContent) {
    lightboxContent.innerHTML = "";
  } else {
    console.error("No lightbox content container available");
  }
};

export const showDialog = (dialogText) => {
    const dialogMessage = dialog.querySelector('.dialog-message')
    dialogMessage.textContent = dialogText
    dialog.classList.add('show-dialog')
}

const clearDialog = () => {
    dialog.classList.remove('show-dialog')
}

